<template>
  <div v-show="activeConditions.length" class="active-conditions">
    <span class="active-conditions__label">{{ $t('筛选条件') }}</span>
    <el-tabs type="card" @tab-remove="removeCondition" @tab-click="handleTabClick">
      <el-tab-pane v-for="item in activeConditions" :key="item.key" :closable="setClosable(item.key)" :name="item.key">
        <span slot="label">
          <ku-table-filter
            :ref="item.key"
            v-model="_queryParams.model[item.key]"
            :options="item.options"
            :query-params="queryParams"
            :origin-table-data="originTableData"
            :current-table-data="tableData"
            v-bind="item"
            class="ku-filter"
            hide-icon
            @on-popover-show="onPopoverShow"
            @search="$emit('fetch')"
          >
            {{ item.title + ' ' + item.op + ' ' }}
            <span style="color: #3a71ff">{{ item.value }}</span>
          </ku-table-filter>
        </span>
      </el-tab-pane>
    </el-tabs>
    <el-tooltip class="item" effect="dark" :content="$t('点击清除所有条件')" placement="top">
      <el-button
        class="active-conditions__clear"
        type="text"
        style="color: #4E5969"
        @click="clearAllTag"
      >
        <i class="iconsimple icon-s-lajitong"></i>
      </el-button>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ActiveConditions',

  props: {
    // 固定筛选条件，禁止删除
    forbidField: {
      type: Array,
      default: _ => []
    },

    // 标签是否可关闭
    closable: {
      type: Boolean,
      default: true
    },

    filterKeyOptions: {
      type: Array,
      default: _ => []
    },

    queryParams: {
      type: Object,
      default: _ => {}
    },

    originTableData: {
      type: Array,
      default: _ => []
    },

    tableData: {
      type: Array,
      default: _ => []
    }
  },

  computed: {
    _queryParams: {
      get() {
        return this.queryParams;
      },
      set(val) {
        this.$emit('update:queryParams', val);
      }
    },

    filterKeyValue() {
      const obj = {};
      this.filterKeyOptions.forEach(v => {
        obj[v.field] = v;
      });
      return obj;
    },

    activeConditions() {
      const arr = [];
      for (const key in this._queryParams.model) {
        const filterItem = this.filterKeyValue[key];
        if (filterItem) {
          const val = this._queryParams.model[key];
          const type = filterItem.type;
          const search = filterItem.search;
          if (!this.isEmpty(val)) {
            const cases2 = {
              input: _ => val,
              checkbox: _ => val.map(v => filterItem.options.find(vv => vv.value === v)?.label || '').join(','),
              datetimerange: _ => val.replace(/,/g, '-'),
              advanced: _ => val.map(v => (v === '' ? `（${this.$t('空白')}）` : v)).join(','),
              default: _ => val
            };
            arr.push({
              ...filterItem,
              key,
              op: search === 'fuzzy' ? this.$t('包含') : this.$t('等于'),
              value: cases2[type] ? cases2[type]() : cases2['default']()
            });
          }
        }
      }
      return arr;
    }
  },

  methods: {
    // 设置筛选标签是否可关闭
    setClosable(key) {
      if (this.forbidField && this.forbidField.length > 0) {
        return this.closable && !this.forbidField.includes(key);
      } else {
        return this.closable;
      }
    },

    // 清楚所有查询条件
    clearAllTag() {
      if (this.forbidField && this.forbidField.length > 0) {
        const keyArr = Object.keys(this._queryParams.model);
        keyArr.map(key => {
          !this.forbidField.includes(key) && (delete this._queryParams.model[key]);
        });
      } else {
        this._queryParams.model = {};
      }

      this.$emit('fetch');
    },

    // 浮框展示时触发的事件
    onPopoverShow() {
      this.$emit('on-popover-show');
    },

    // 标签关闭点击
    removeCondition(key) {
      if (this.forbidField && this.forbidField.length > 0) {
        !this.forbidField.includes(key) && (this._queryParams.model[key] = undefined);
      } else {
        this._queryParams.model[key] = undefined;
      }
      this.$emit('fetch');
    },

    // 点击tab
    handleTabClick(tabItemInstance) {
      this.$refs[tabItemInstance.name][0].doToggle();
    },

    // 判断是否为空
    isEmpty(value) {
      const type = Object.prototype.toString.call(value);
      const cases = {
        '[object String]': _ => !value,
        '[object Number]': _ => !value,
        '[object Boolean]': _ => !value,
        '[object Object]': _ => !Object.keys(value).length,
        '[object Array]': _ => !value.length,
        '[object Null]': _ => true,
        '[object Undefined]': _ => true,
        default: _ => false
      };
      return cases[type] ? cases[type]() : cases['default']();
    }

  }
};
</script>

<style lang="scss" scoped>
::v-deep .table-filter-popover .content .el-input-group__append{
  padding: 0px !important;
}

.active-conditions {
  background-color: $fill-disabled;
  padding: 4px 8px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  &__clear {
    padding: 0px;
    margin-left: auto;
    flex-shrink: 0;
  }
  &__label {
    float: left;
    color: #1d2129;
    font-size: 14px;
    height: 22px;
    line-height: 22px;
    margin-right: 10px;
    flex-shrink: 0;
  }
  ::v-deep .el-tabs {
    width: calc(100% - 122px);
    margin-right: 10px;
    &__header {
      border: none;
      margin-bottom: 0px;
      .el-tabs__nav,
      .el-tabs__item {
        border: none;
      }
      .el-tabs__nav {
        &-prev,
        &-next {
          height: 24px;
          line-height: 24px;
          i {
            color: #86909c;
            font-weight: 700;
          }
        }
      }
      .el-tabs__item {
        height: 22px;
        line-height: 22px;
        box-sizing: content-box;
        color: $tooltip-dark;
        background-color: #e5e6e8;
        border-radius: 2px;
        display: inline-flex;
        &:focus.is-active.is-focus:not(:active) {
          box-shadow: unset;
          border-radius: unset;
        }
        &:not(:last-of-type) {
          margin-right: 8px;
        }
        &,
        &.is-active,
        &.is-closable {
          padding: 1px 10px;
        }
        &:hover {
          background-color: $fill-hover;
        }
        .el-icon-close {
          width: 14px;
          height: 24px;
          line-height: 24px;
          background-color: unset;
          color: unset;
        }
      }
      .el-tabs__nav-wrap{
        margin-bottom: unset;
      }
    }
  }
}
</style>
